(function(){
     'use strict';

     angular
        .module('app')
        .factory('UserService', UserService);

    UserService.$inject = ['$http',"upload"];
 
    function UserService($http,upload){

        var service= {
           registrarUsuario:registrarUsuario,
           recuperarPass:recuperarPass,
           cambiarPass:cambiarPass,
           getCountries:getCountries,
           getComittee:getComittee,
           getDirectory:getDirectory,
           getAddresses:getAddresses,
           getUpdateAddress:getUpdateAddress,
           deleteAddress:deleteAddress,
           getAccount:getAccount,
           saveAccount:saveAccount,
           updateUser:updateUser,
           deleteAccount:deleteAccount,
           userPayment:userPayment,
           SaveJob: SaveJob,
           userPaymentWithDoc:userPaymentWithDoc,
           getProducts:getProducts,
           getUsers:getUsers


        };

        return service;

        function recuperarPass(datos,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               datos:datos,
               lang_id:lang_id
            });
            $http.post('/middleware/recuperarpass', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function cambiarPass(newpass,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               newpass:newpass,
               lang_id:lang_id
            });
            $http.post('/middleware/newpass', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        

        
        function registrarUsuario(registro,callback)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               registro:registro,
               lang_id:lang_id
            });
            $http.post('/middleware/registrarusuario', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                callback(data.data);
            }
            function getContentFailed(data){
                
                return false;
            }
        }


        function getCountries()
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id
            });
            return $http.post('/middleware/countries', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }


        function getComittee()
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id
            });
            return $http.post('/middleware/comittee', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getDirectory(country,comittee,fullname,company,offset)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               country:country,
               comittee:comittee,
               fullname:fullname,
               company:company,
               offset:offset
            });
            return $http.post('/middleware/directory', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }

       function getAddresses()
        {
            var config = {
                cache:false,
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
            });
            return $http.post('/middleware/address', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function saveAccount(account)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               data:account
            });
            return $http.post('/middleware/saveaccount', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }

        }

        function deleteAccount(sendData)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               data:sendData,
            });
            return $http.post('/middleware/deleteaccount', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }

        }

        function getAccount()
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
            });
            return $http.post('/middleware/account', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getUpdateAddress(sendData)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               data:sendData,
            });
            
            return $http.post('/middleware/updateaddress', data, config)
            .then(getContentSuccess,getContentFailed);

            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function updateUser(sendData)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               data:sendData,
            });
            return $http.post('/middleware/updateuser', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }


        function deleteAddress(sendData)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               data:sendData,
            });
            return $http.post('/middleware/deleteaddress', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }
        
        function userPayment(sendData)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               data:sendData,
            });
            return $http.post('/middleware/userpayment', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function userPaymentWithDoc(sendData)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               data:sendData,
            });
            return $http.post('/middleware/userpaymentdoc', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }

        function getProducts(address,membership,code)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               address:address.addressBilling,
               membership:membership,
               code:code
            });
            
            return $http.post('/middleware/products', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }


        function getUsers(address,membership,code)
        {
            var config = {
                headers : {
                    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8;',
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = $.param({
               lang_id:lang_id,
               
            });
            
            return $http.get('/middleware/users', data, config)
            .then(getContentSuccess,getContentFailed);
            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }

     function SaveJob(job)
        {
            var config = {
                cache:false,
                headers : {
                    'Content-Type': undefined,
                    'Cache-Control' : 'no-cache'
                }
            };
            var data = {
               lang_id:lang_id,
               "EventosForm[pdf]":job.pdf,
               "EventosForm[title]":job.title,
               "EventosForm[description]":job.description,
               "EventosForm[job]":job.job
            };

        

            return $http({
                    method: 'POST',
                    url:'/middleware/job', 
                    data:data, 
                    headers:config.headers,
                    cache:config.cache,
                    transformRequest: function (data, headersGetter) {
                        var formData = new FormData();
                            angular.forEach(data, function (value, key) {
                                    formData.append(key, value);
                            });
                            return formData;
                        }
                    })

            .then(getContentSuccess,getContentFailed);

            function getContentSuccess(data){ 
                return data.data;
            }
            function getContentFailed(data){
                
                return false;
            }
        }
       

    }
})();